


















































import Vue from "vue";
import moment from "moment";
import Web3 from "web3";
import { setIntervalAsync, clearIntervalAsync, SetIntervalAsyncTimer } from "set-interval-async/fixed";

export default Vue.extend({
  name: "AddLiquidityETHWatcher",

  data: () => ({
    isStarted: false as boolean,
    tokenAddress: "" as string,
    btnColor: "primary" as string,
    btnText: "Start" as string,
    items: [] as Array<any>,
    error: "" as string,
    interval: undefined as SetIntervalAsyncTimer | undefined,
  }),
  methods: {
    async click(): Promise<void> {
      if (this.isStarted) {
        if (this.interval != undefined) {
          await clearIntervalAsync(this.interval);
        }
        this.error = "";
        this.btnColor = "primary";
        this.btnText = "Start";
        this.isStarted = false;
        return;
      }

      const web3 = new Web3(new Web3.providers.HttpProvider("https://bsc-dataseed1.defibit.io:443"));
      web3.extend({
        property: "txpool",
        methods: [
          {
            name: "content",
            call: "txpool_content",
          },
        ],
      });

      const pancakeRouterV2ContractAddress = "0x10ED43C718714eb63d5aA57B78B54704E256024E";
      const addLiquidityEthMethodId = "0xf305d719";
      const addLiquidityEthMethodAbi = ["address", "uint256", "uint256", "uint256", "address", "uint256"];

      this.isStarted = true;
      this.btnColor = "secondary";
      this.btnText = "Stop";
      this.items.splice(0);

      // transaction の監視を開始
      const checkedTransactionHashs: string[] = [];
      this.interval = setIntervalAsync(async () => {
        const result = await (web3 as any).txpool.content();
        const pendingTransactions: any[] = Object.values(result.pending);
        pendingTransactions.forEach((pendingTransaction) => {
          const transactions: any[] = Object.values(pendingTransaction);
          transactions
            .filter((transaction) => !checkedTransactionHashs.includes(transaction.hash))
            .forEach((transaction) => {
              checkedTransactionHashs.push(transaction.hash);
              if (transaction != null && transaction.to == pancakeRouterV2ContractAddress.toLowerCase()) {
                const methodId = transaction.input.slice(0, 10);
                if (methodId == addLiquidityEthMethodId) {
                  const parameters = `0x${transaction.input.slice(10)}`;
                  const decodedParameters = web3.eth.abi.decodeParameters(addLiquidityEthMethodAbi, parameters);
                  const tokenContractAddress = decodedParameters["0"];
                  const amountEthMin = decodedParameters["3"];
                  if (!this.tokenAddress || this.tokenAddress.toLowerCase() == tokenContractAddress.toLowerCase()) {
                    const index = this.items.findIndex((item) => item.transactionHash == transaction.hash);
                    if (index === -1) {
                      this.items.push({
                        date: `${moment().format("YYYY/MM/DD HH:mm:ss")}`,
                        pair: `BNB / ${tokenContractAddress.slice(0, 6)}...${tokenContractAddress.slice(-3)}`,
                        bnb: Web3.utils.fromWei(amountEthMin, "ether").slice(0, 5),
                        transactionHash: transaction.hash,
                        transactionHashLink: `https://bscscan.com/tx/${transaction.hash}`,
                      });
                    }
                  }
                }
              }
            });
          if (checkedTransactionHashs.length > 20000) {
            const deleteCount = checkedTransactionHashs.length - 20000;
            checkedTransactionHashs.splice(0, deleteCount);
          }
        });
      }, 10);
    },
  },
});
